const userClientKeys = {
  useUser: 'user',
  useBootstrapData: 'bootstrap-data',
};

const accountClientKeys = {
  useProfileShow: 'profile',
  useUserJobsIndex: 'user-jobs',
};

const guidanceClientKeys = {
  useUserFeedback: 'user-feedback',
};

const recommendationClientKeys = {
  useRecommendationProfile: 'recommendation-profile',
  useRecommendedActivities: 'recommended-activities',
  useCourseRecommendations: 'course-recommendations',
};

const taxonomyClientKeys = {
  useUserPrioritySkillSetsIndex: 'user-priority-skill-sets',
  useSkillSearch: 'skill-search',
  useJobTitlesSearch: 'job-titles-search',
};

const idpClientKeys = {
  usePlanActivitiesIndex: 'plan-activities',
  usePlansIndex: 'plans',
  usePlanShow: 'show-plan',
  useProfileBasedRecommendationShow: 'profile-based-recommendation-show',
  useProfileBasedRecommendationPolling: 'profile-based-recommendation-polling',
  useCompleteProfileBasedRecommendation:
    'complete-profile-based-recommendation',
  useRedoRecommendation: 'redo-recommendation',
};

const learningPathClientKeys = {
  usePathsIndex: 'paths',
  usePathsByScope: 'paths-by-scope',
  useShowPath: 'show-path',
  useManagePathsIndex: 'manage-paths',
  useShowPathManagement: 'show-path-management',
  useCreatePath: 'create-path',
  useEditPath: 'edit-path',
  useDeletePath: 'delete-path',
  useReorderPaths: 'reorder-paths',
};

const refundClientKeys = {
  useResourceApprovalsIndex: 'resource-approvals',
  usePoliciesIndex: 'policies',
  useAvailableForRefundRequest: 'available-for-refund-request',
  useResourceApprovalShow: 'resource-approval-show',
  useRequestRefundableAmount: 'request-refundable-amount',
  useRefundRequestShow: 'refund-request',
  useResourceApprovalsToReview: 'use-resource-approvals-to-review',
  useResourceApprovalDetails: 'resource-approvals-details',
};

const catalogClientKeys = {
  useInstitutionsLogo: 'institutions-logo',
  useOfferFilters: 'offer-filters',
  useCatalogOffer: 'offer',
  catalogSearch: 'catalog-search',
};

const courseClientKeys = {
  useCheckSubscriptionLimit: 'check-subscription-limit',
  useGetCertificateUrl: 'get-certificate-url',
  useRegistrationShow: 'registration-show',
  useCourseDetails: 'course-details',
};

const ordersClientKeys = {
  useCheckOrder: 'check-order',
};

const learningClientKeys = {
  useAcademicSituationsIndex: 'academic-situations',
  useAcademicSituationShow: 'academic-situation-show',
};

export const clientKeys = {
  ...userClientKeys,
  ...accountClientKeys,
  ...guidanceClientKeys,
  ...recommendationClientKeys,
  ...taxonomyClientKeys,
  ...idpClientKeys,
  ...learningPathClientKeys,
  ...refundClientKeys,
  ...catalogClientKeys,
  ...courseClientKeys,
  ...ordersClientKeys,
  ...learningClientKeys,
};
